import React from 'react';
import Tags from '../../../../elements/Tags/Tags';
import { useScheduleTags } from '../../../../../data/hooks/schedule/useScheduleTags';

function ScheduleItemTags(props) {
    const { event,  session } = props,
        categories = useScheduleTags(event.id),
        tags = session.categories;

    return (
        <div className="content">
            <Tags categories={categories} tags={tags} />
        </div>
    );
}

export default ScheduleItemTags;
